export default "__VITE_ASSET__C_cp1fw4__"